import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'
import { LoginComponent } from '../../../../../Components/Login'

const useStyles = makeStyles((theme) => ({
  root: {

  }
}))

export const DialogLogin = ({
  open = false,
  onClose,
  onLoginSuccess, 
  onForgotPassword
}) => {
  const classes = useStyles()
  return (
    <Dialog
      className={classes.root}
      open={open}
      onClose={onClose}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle>Login</DialogTitle>
      <DialogContent>
        <LoginComponent
          onLoginSuccess={onLoginSuccess}
          onForgotPassword={onForgotPassword}
        />
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
